import { useCartContext } from "app/providers/CartProvider";
import SampleSaleDoorPriceTable from "entities/configurator/sample-sale-door-price-table";
import StandardProductPriceTable from "entities/configurator/standard-product-price-table";
import ProductItemExtra from "entities/product-item-extra";
import ProductsTotal from "entities/products-total";
import CheckoutFooterButtons from "features/checkout/footer-buttons";
import CheckoutFooterLinks from "features/checkout/footer-links";
import { useState } from "react";
import { concatClassnames } from "shared/utils/concatClassnames";
import { ProductContext } from "shared/utils/productContext";
import AddVoucherModal from "widgets/shared/add-voucher-modal";

const CheckoutOverviewFooter = () => {
  const [isVoucherModalOpen, setIsVoucherModalOpen] = useState(false);

  const cartContext = useCartContext();
  const cart = cartContext.getCart();
  const isSampleSale = cartContext.isSampleSale;
  const productContext =
    cart.products.length > 0
      ? ProductContext.DoorContext
      : ProductContext.StandardProductContext;

  return (
    <footer className="gg-bg-dark-blue gg-px-6 gg-pb-11 gg-pt-8 gg-text-white sm:gg-px-14 md:gg-px-32 lg:gg-px-14 xl:gg-px-32">
      <div className="gg-mb-8 gg-grid gg-grid-cols-12 gg-border-b gg-border-white-600 gg-pb-7">
        <div className="gg-col-span-12 gg-mb-6 gg-grid gg-items-start gg-gap-x-10 gg-gap-y-6 lg:gg-col-span-8 lg:gg-mb-0 lg:gg-grid-cols-2">
          {isSampleSale ? (
            <SampleSaleDoorPriceTable cart={cart} />
          ) : (
            <StandardProductPriceTable context={cartContext} entity={cart} />
          )}
          <ProductItemExtra entity={cart} className="gg-text-white-800" />
        </div>

        <div
          className={concatClassnames(
            "gg-col-span-12 gg-justify-self-end lg:gg-col-span-4",
          )}
        >
          <ProductsTotal
            entity={cart}
            context={cartContext}
            isSampleSale={isSampleSale}
            isBusiness={cartContext.containsZakelijkProducts}
          />
        </div>
      </div>

      <div className="gg-grid gg-grid-cols-1 gg-gap-6 gg-text-dark-blue sm:gg-items-center sm:gg-gap-8 lg:gg-grid-cols-3 lg:gg-gap-10">
        <CheckoutFooterLinks setIsVoucherModalOpen={setIsVoucherModalOpen} />
        <CheckoutFooterButtons />
      </div>

      <AddVoucherModal
        isOpen={isVoucherModalOpen}
        setIsOpen={setIsVoucherModalOpen}
        productContext={productContext}
      />
    </footer>
  );
};
export default CheckoutOverviewFooter;
